<template>
  <div style="width: 100%; display: flex; padding-left: 50px">
    <div style="max-width: 45%; height: 100%">
      <div style="font-size: 20px;padding-bottom: 20px;">
        <div class="tip-icon"> 未分配角色 </div>

      </div>

      <!-- 表格 -->
      <div style="padding-bottom: 3%;overflow: hidden;">
        <div style="width: 100%;float: left;">
          <div style="
                font-size: 14px;
                height: 30px;
                line-height: 30px;
                padding-right: 2%;
                float: left;
              ">
            角色名称:
          </div>
          <div style="float: left;">
            <a-input v-model="conditionLike.roleName" :allowClear="true" placeholder="请输入角色名称" />
          </div>
          <div style="float: left;margin-left: 9px;">
            <a-button class="btone" @click="queryList(1)">查询</a-button>
          </div>
        </div>
      </div>
      <a-table  class="antd-table table" :columns="columns" :row-selection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
        columnWidth: 20
      }" :rowKey="(record, index) => {
    return record.id
  }
  " :data-source="tableData" :pagination="false" :loading="Tableloading" bordered size="small">
  <span slot="index" slot-scope="text,record,index">
    {{index + (pageNum-1) * pageSize + 1}}
  </span>
        <span slot="roleStatus" slot-scope="text, record">
          <span v-if="record.roleStatus == 1"><a-badge color="cyan" /></span>
          <span v-else-if="record.roleStatus == 2"><a-badge color="red" /></span>
          {{ record.roleStatus | DictionaryFilter('ROLE_STATUS') }}
        </span>

        <span slot="roleType" slot-scope="text, record">
          {{ record.roleType | DictionaryFilter('ROLE_TYPE') }}
        </span>
      </a-table>

      <!-- 分页 -->
      <div class="base-pagination" style="padding-top: 10px;">
        <div class="total-view">
          共{{ totalRows }}条数据，第{{ pageNum }}/{{ totalPage }}页
        </div>
        <div class="pagination-buttons">
          <a-pagination v-model="pageNum" :total="totalRows" :defaultPageSize="pageSize" show-less-items
            @change="changePageFn($event)" />
        </div>
      </div>
    </div>
    <div style="
        font-size: 40px;
        padding-top: 19%;
        padding-left: 10px;
        padding-right: 10px;
      ">
      <div>
        <a-button class="btaction" style="width: 80px" @click="add()">
          添加
        </a-button>
      </div>
      <div>
        <a-button class="btaction" style="width: 80px" @click="del()">
          移除
        </a-button>
      </div>
    </div>
    <div style="max-width: 45%;height: 100%">
      <div style="display: flex;justify-content: space-between;">
        <div style="font-size: 20px;padding-bottom: 20px;">
          <div class="tip-icon"> 已分配角色 </div>
          

        </div>
        <div>
          <a-button class="bttwo" @click="showReturn()">返回上级菜单</a-button>
        </div>
      </div>
      <div style="padding-bottom: 3%;overflow: hidden;">
          <div style="width: 100%;float: left;">
            <div style="
                font-size: 14px;
                height: 30px;
                line-height: 30px;
                padding-right: 2%;
                float: left;
              ">
              角色名称:
            </div>
            <div style="float: left;">
              <a-input v-model="conditionLikeright.roleName" :allowClear="true" placeholder="请输入角色名称" />
            </div>
            <div style="float: left;margin-left: 9px;">
              <a-button class="btone" @click="queryListright(1)">查询</a-button>
            </div>
          </div>
      </div>
      <a-table class="antd-table table" :columns="columnsright" :data-source="tableDataright" :pagination="false" :rowKey="(record, index) => {
          return record.id
        }
        " :row-selection="{
    selectedRowKeys: selectedRowKeysright,
    onChange: onSelectChangeright,
    columnWidth: 20
  }" :loading="Tableloadingright" bordered size="small">
  <span slot="index" slot-scope="text,record,index">
    {{index + (pageNumright-1) * pageSizeright + 1}}
  </span>
        <span slot="roleStatus" slot-scope="text, record">
          <span v-if="record.roleStatus == 1"><a-badge color="cyan" /></span>
          <span v-else-if="record.roleStatus == 2"><a-badge color="red" /></span>
          {{ record.roleStatus | DictionaryFilter('ROLE_STATUS') }}
        </span>

        <span slot="roleType" slot-scope="text, record">
          {{ record.roleType | DictionaryFilter('ROLE_TYPE') }}
        </span>
      </a-table>

      <!-- 分页 -->
      <div class="base-pagination" style="padding-top: 10px;">
        <div class="total-view">
          共{{ totalRowsright }}条数据，第{{ pageNumright }}/{{
            totalPageright
          }}页
        </div>
        <div class="pagination-buttons">
          <a-pagination v-model="pageNumright" :total="totalRowsright" :defaultPageSize="pageSizeright" show-less-items
            @change="changePageFnright($event)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  userbyrole,
  useraddrole,
  userdelerole,
  userbyroles,
  userStatus
} from '../../../api/api.js'
import { DictionaryService } from '@common/services/dictionary.service'
export default {
  data() {
    return {
      rolStaList: [],
      rolTpList: [],
      //左
      tableData: [],
      Tableloading: false,
      selectedRowKeys: [],
      id: '',
      // // 分页相关
      pageNum: 1,
      pageSize: 10,
      totalRows: null,
      totalPage: '',
      conditionLike: {
        roleName: ''
      },
      //右
      conditionLikeright: {
        roleName: ''
      },
      tableDataright: [],
      selectedRowKeysright: [],
      Tableloadingright: false,
      pageNumright: 1,
      pageSizeright: 10,
      totalRowsright: null,
      totalPageright: '',
      columns: [
      { title: "序号",align: "center", dataIndex: 'index',width:25, key : 'index', ellipsis: true,scopedSlots: { customRender: 'index' }},
        {
          title: ' 角色名字',
          align: 'center',
          dataIndex: 'roleName',
          width: 50,
          key: 'roleName',
          ellipsis: true,
        },
        {
          title: '角色状态',
          align: 'center',
          dataIndex: 'roleStatus',
          width: 50,
          key: 'roleStatus',
          ellipsis: true,
          scopedSlots: { customRender: 'roleStatus' },
        },
        {
          title: '角色类型',
          align: 'center',
          dataIndex: 'roleType',
          width: 50,
          key: 'roleType',
          ellipsis: true,
          scopedSlots: { customRender: 'roleType' },
        },
      ],
      columnsright: [
      { title: "序号",align: "center", dataIndex: 'index',width:25, key : 'index', ellipsis: true,scopedSlots: { customRender: 'index' }},
        {
          title: ' 角色名字',
          align: 'center',
          dataIndex: 'roleName',
          width: 50,
          key: 'roleName',
          ellipsis: true,
        },
        {
          title: '角色状态',
          align: 'center',
          dataIndex: 'roleStatus',
          width: 50,
          key: 'roleStatus',
          ellipsis: true,
          scopedSlots: { customRender: 'roleStatus' },
        },
        {
          title: '角色类型',
          align: 'center',
          dataIndex: 'roleType',
          width: 50,
          key: 'roleType',
          ellipsis: true,
          scopedSlots: { customRender: 'roleType' },
        },
      ],
    }
  },
  activated() {
    this.id = this.$route.query.id;
    DictionaryService.getAllNeedDic(['ROLE_STATUS', 'ROLE_TYPE']).then(
      (res) => {
        this.$forceUpdate();
        this.rolStaList = DictionaryService.getOptions('ROLE_STATUS')
        this.rolTpList = DictionaryService.getOptions('ROLE_TYPE')

        this.queryList(1)
        this.queryListright(1)
      }
    )
  },
  mounted() {



  },
  // watch: {
  //       $route(to, from){


  //       },
  //   },
  methods: {
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    onSelectChangeright(selectedRowKeys) {
      this.selectedRowKeysright = selectedRowKeys
    },
    queryList(sum = 2) {
      if (sum == 1) this.pageNum = 1
      this.Tableloading = true
      let pageParam = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        orderBy: '',
      }
      userbyrole({ pageParam: pageParam, content: { userId: this.id, roleName: this.conditionLike.roleName } }).then(
        (res) => {
          this.Tableloading = false
          this.tableData = res.content.rows
          this.totalRows = res.content.page.totalRows
          this.totalPage = Math.ceil(this.totalRows / this.pageSize)
        },
        (err) => {
          this.$message.error('查询失败')
          this.Tableloading = false
        }
      )
    },
    // 分页修改
    changePageFn(event) {
      this.pageNum = event
     
        this.queryList()
     
    },
    changePageFnright(event) {
      this.pageNumright = event
    
        this.queryListright()
  
    
      
    },
    queryListright(sum = 2) {
      if (sum == 1) this.pageNumright = 1
      this.Tableloadingright = true
      let pageParam = {
        pageNum: this.pageNumright,
        pageSize: this.pageSizeright,
        orderBy: '',
      }
      userbyroles({ pageParam: pageParam, content: { userId: this.id, roleName: this.conditionLikeright.roleName } }).then(
        (res) => {
          this.Tableloadingright = false
          this.tableDataright = res.content.rows
          this.totalRowsright = res.content.page.totalRows
          this.totalPageright = Math.ceil(
            this.totalRowsright / this.pageSizeright
          )
        },
        (err) => {
          this.$message.error('查询失败')
          this.Tableloadingright = false
        }
      )
    },
    showReturn() {

      this.$router.push({
        path: "/home/system/user",
      });

    },
    add() {
      if (this.selectedRowKeys.length > 0) {
        useraddrole({ roleIds: this.selectedRowKeys, userId: this.id }).then(
          (res) => {
            this.$message.success('添加成功')
            // this.selectedRowKeysright = []
            this.selectedRowKeys = []
            this.queryList(1)
            this.queryListright(1)
          },
          (err) => {
            this.$message.error('添加失败')
          }
        )
      } else {
        this.$message.warning('请先选择')
      }

    },
    del() {
      if (this.selectedRowKeysright.length > 0) {
        userdelerole({
          roleIds: this.selectedRowKeysright,
          userId: this.id,
        }).then(
          (res) => {
            this.$message.success('删除成功')
            this.selectedRowKeysright = []
            this.selectedRowKeys = []
            this.queryList(1)
            this.queryListright(1)
          },
          (err) => {
            this.$message.error('删除失败')
          }
        )
      } else {
        this.$message.warning('请先选择')
      }

    },
  },
}
</script>

<style  lang="less" scoped="scoped">
* {
  margin: 0;
  padding: 0;
}

.btone {
  width: 64px;
  margin-right: 20px;
}

.bttwo {
  width: 100px;
}

.antd-table {
  
  ::v-deep .ant-table {
    // margin-top: 10px !important;
  }

  ::v-deep .ant-table-thead th {
    background: rgb(224, 243, 254);
  }

  ::v-deep .ant-table-thead {
    background: rgb(224, 243, 254);
  }

  ::v-deep .ant-table-body {
    margin: 0 !important;
    overflow-y: auto !important;
    height: calc(100vh - 310px);
  }

  ::v-deep .ant-pagination-item-active {
    border-color: #4954b3;

    a {
      color: #4954b3;
    }
  }

  /deep/ .ant-table-tbody>tr>td {
    padding: 15px !important;
  }

  ::v-deep .ant-table-thead th {
    border-right: 1px solid #d0d5e9;
  }

  ::v-deep .ant-table-tbody td {
    // border-right:none ;
  }

  ::v-deep .ant-table-small.ant-table-bordered .ant-table-placeholder {
    display: none;
  }
}

/deep/ .ant-input {
  width: 160px;
}
</style>